// gatsby-browser.js

// Function to create and initialize particles background
const createParticlesBackground = () => {
  // Remove existing particles if any
  const existingParticles = document.getElementById('particles-background');
  if (existingParticles) {
    existingParticles.remove();
  }

  // Create particles container
  const particlesContainer = document.createElement('div');
  particlesContainer.id = 'particles-background';
  particlesContainer.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    pointer-events: none;
    background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%);
  `;

  // Create particles
  for (let i = 0; i < 50; i++) {
    const particle = document.createElement('div');
    particle.className = 'particle';
    particle.style.cssText = `
      position: absolute;
      width: ${Math.random() * 4 + 1}px;
      height: ${Math.random() * 4 + 1}px;
      background: rgba(255, 255, 255, ${Math.random() * 0.8 + 0.2});
      border-radius: 50%;
      animation: float ${Math.random() * 20 + 10}s infinite linear;
      left: ${Math.random() * 100}%;
      top: ${Math.random() * 100}%;
    `;
    particlesContainer.appendChild(particle);
  }

  // Add CSS animations
  const style = document.createElement('style');
  style.textContent = `
    @keyframes float {
      0% {
        transform: translateY(0px) translateX(0px) rotate(0deg);
        opacity: 1;
      }
      33% {
        transform: translateY(-30px) translateX(30px) rotate(120deg);
        opacity: 0.8;
      }
      66% {
        transform: translateY(30px) translateX(-20px) rotate(240deg);
        opacity: 0.6;
      }
      100% {
        transform: translateY(0px) translateX(0px) rotate(360deg);
        opacity: 1;
      }
    }

    .particle {
      transition: all 0.3s ease;
    }

    .particle:hover {
      transform: scale(1.5) !important;
      opacity: 1 !important;
    }

    /* Add subtle glow effect */
    #particles-background::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(circle at 50% 50%, rgba(100, 149, 237, 0.1) 0%, transparent 50%);
      pointer-events: none;
    }
  `;

  // Insert particles and styles
  document.head.appendChild(style);
  document.body.insertBefore(particlesContainer, document.body.firstChild);

  // Add mouse interaction
  let mouseX = 0;
  let mouseY = 0;

  const handleMouseMove = (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;

    // Create ripple effect near mouse
    const particles = document.querySelectorAll('.particle');
    particles.forEach(particle => {
      const rect = particle.getBoundingClientRect();
      const particleX = rect.left + rect.width / 2;
      const particleY = rect.top + rect.height / 2;
      
      const distance = Math.sqrt(
        Math.pow(mouseX - particleX, 2) + Math.pow(mouseY - particleY, 2)
      );

      if (distance < 100) {
        const force = (100 - distance) / 100;
        const angle = Math.atan2(mouseY - particleY, mouseX - particleX);
        
        particle.style.transform = `
          translate(${Math.cos(angle) * force * 20}px, ${Math.sin(angle) * force * 20}px) 
          scale(${1 + force * 0.5})
        `;
        particle.style.opacity = Math.min(1, 0.5 + force * 0.5);
      } else {
        particle.style.transform = '';
        particle.style.opacity = '';
      }
    });
  };

  document.addEventListener('mousemove', handleMouseMove);
  
  // Store cleanup function
  particlesContainer._cleanup = () => {
    document.removeEventListener('mousemove', handleMouseMove);
  };
};

// Add body classes when the initial render happens
exports.onInitialClientRender = () => {
  document.body.className = 'body'
  // add data-bs-theme="dark" to html tag
  document.documentElement.setAttribute('data-bs-theme', 'dark');
  document.body.setAttribute('data-bs-target', '#header-nav');
  document.body.setAttribute('data-bs-offset', '0');
  
  // Initialize particles background after a brief delay
  setTimeout(() => {
    createParticlesBackground();
  }, 100);
}

// Ensure body classes are maintained on route changes
exports.onRouteUpdate = () => {
  document.body.className = 'smooth-scroll-yes'
  
  // Reinitialize particles on route change
  setTimeout(() => {
    createParticlesBackground();
  }, 100);
}